<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <currency-field
          :label="customLabel.sf_currency"
          v-model="form.main.sf_currency"
          :use-default="true"
          slot="sf_currency"
        />
        <div class="weui-cell" slot="sf_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sf_taxrate || "税率"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.sf_taxrate"
              placeholder="请输入"
            />
          </div>
        </div>
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="sf_clashway"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.sf_clashway || "核销类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.sf_clashway"
              placeholder="请选择"
            >
              <option value="ALL">任意订单自动核销</option>
              <option value="client">按备货客户核销</option>
            </select>
          </div>
        </div>
        <custom-field 
          :label="customLabel.sf_text1 || '自定义字段1'"
          v-model="form.main.sf_text1" :caller="caller" fieldName="sf_text1"
          slot="sf_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.sf_text2 || '自定义字段2'"
          v-model="form.main.sf_text2" :caller="caller" fieldName="sf_text2"
          slot="sf_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.sf_text3 || '自定义字段3'"
          v-model="form.main.sf_text3" :caller="caller" fieldName="sf_text3"
          slot="sf_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.sf_text4 || '自定义字段4'"
          v-model="form.main.sf_text4" :caller="caller" fieldName="sf_text4"
          slot="sf_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.sf_text5 || '自定义字段5'"
          v-model="form.main.sf_text5" :caller="caller" fieldName="sf_text5"
          slot="sf_text5" hidden="true"
        />
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <product-field
             v-model="item.productDTO.pr_detail"
              @select="onItemSelectProduct($event, item)"
              :label="customLabel.pr_detail"
              slot="pr_detail"
            />
            <div
              class="weui-cell"
              v-if="item.productDTO.pr_orispeccode"
              slot="pr_orispeccode"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_orispeccode || "型号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.productDTO.pr_orispeccode }}
              </div>
            </div>
            <div
              class="weui-cell"
              v-if="item.productDTO.pr_spec"
              slot="pr_spec"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_spec || "规格"
                }}</label>
              </div>
              <div class="weui-cell__bd">{{ item.productDTO.pr_spec }}</div>
            </div>
            <div class="weui-cell" slot="sd_qty">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.sd_qty || "数量"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.sd_qty"
                  placeholder="请填写"
                />
              </div>
              <div class="weui-cell__ft">{{ item.productDTO.pr_unit }}</div>
            </div>
            <customer-field
              :label="customLabel.sd_custname || '客户名称'"
              slot="sd_custname"
              v-model="item.sd_custname"
              @select="onItemSelectCustomer($event, item)"
            />
            <date-field
              :label="customLabel.sd_delivery || '交货日期'"
              v-model="item.sd_delivery"
              slot="sd_delivery"
            />
            <custom-field 
            :label="customLabel.sd_text1 || '自定义字段1'"
            v-model="item.sd_text1" :caller="caller" fieldName="sd_text1"
            slot="sd_text1" hidden="true"
          />
          <custom-field
            :label="customLabel.sd_text2 || '自定义字段2'"
            v-model="item.sd_text2" :caller="caller" fieldName="sd_text2"
            slot="sd_text2" hidden="true"
          />
          <custom-field 
            :label="customLabel.sd_text3 || '自定义字段3'"
            v-model="item.sd_text3" :caller="caller" fieldName="sd_text3"
            slot="sd_text3" hidden="true"
          />
          <custom-field 
            :label="customLabel.sd_text4 || '自定义字段4'"
            v-model="item.sd_text4" :caller="caller" fieldName="sd_text4"
            slot="sd_text4" hidden="true"
          />
          <custom-field 
            :label="customLabel.sd_text5 || '自定义字段5'"
            v-model="item.sd_text5" :caller="caller" fieldName="sd_text5"
            slot="sd_text5" hidden="true"
          />
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import ProductField from "@/components/field/ProductField.vue";
import DateField from "@/components/field/DateField.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  components: {
    CustomLayout,
    CustomerField,
    CurrencyField,
    ProductField,
    DateField,
    CustomField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/sale/saleforecast",
      codeField: "sf_code",
      statusField: "sf_statuscode",
      caller: "SaleForecast",
      xtype: "sale-saleforecast-formpanel",
      form: {
        main: {
          sf_currency: null,
          sf_taxrate: 0,
          sf_clashway: "ALL",
        },
        items: [
          {
            sd_qty: 0,
            productDTO: {},
          },
        ],
      },
    };
  },
  methods: {
    /**
     * 选择明细客户
     */
    onItemSelectCustomer(selection, item) {
      item.sd_custid = selection.id;
      item.sd_custcode = selection.cu_code;
    },
    /**
     * 选择明细产品
     */
    onItemSelectProduct(selection, item) {
      item.sd_prodid = selection.id;
      item.sd_prodcode = selection.pr_code;
      item.productDTO = Object.assign({}, selection);
    },
    onSelectProduct(selection, item) {
      item.productDTO.pr_prodid = selection.id;
      item.productDTO.pr_prodcode = selection.pr_code;
      item.productDTO.pr_detail = selection.pr_detail;
      item.productDTO.pr_brand = selection.pr_brand;
      item.productDTO.pr_orispeccode = selection.pr_orispeccode;
      item.productDTO.pr_spec = selection.pr_spec;
      item.productDTO.pr_unit = selection.pr_unit;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.sf_currency) {
        me.$weui.topTips("请选择币种", 2000);
      } else {
        var count = 0;
        items.forEach(function (item) {
          if (!item.sd_prodid) {
            me.$weui.topTips(`第${count + 1}行产品未选择`, 2000);
            return false;
          } else if (!item.sd_qty || item.sd_qty <= 0) {
            me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
            return false;
          } else {
            count++;
            item.sd_detno = count;
          }
        });
        checked = count == items.length;
      }

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        sd_qty: 0,
        productDTO: {},
      });
    },
  },
};
</script>